export enum FeederBand {
  BandA = 1,
  BandB = 2,
  BandC = 3,
  BandD = 4,
  BandE = 5,
}

export const feederBandOptions = [
  { id: FeederBand.BandA, name: 'Band A' },
  { id: FeederBand.BandB, name: 'Band B' },
  { id: FeederBand.BandC, name: 'Band C' },
  { id: FeederBand.BandD, name: 'Band D' },
  { id: FeederBand.BandE, name: 'Band E' },
];
